/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SkuBatchUploadResVo } from './SkuBatchUploadResVo';
import {
    SkuBatchUploadResVoFromJSON,
    SkuBatchUploadResVoFromJSONTyped,
    SkuBatchUploadResVoToJSON,
    SkuBatchUploadResVoToJSONTyped,
} from './SkuBatchUploadResVo';

/**
 * 
 * @export
 * @interface ResponseSkuBatchUploadResVo
 */
export interface ResponseSkuBatchUploadResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseSkuBatchUploadResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseSkuBatchUploadResVo
     */
    message?: string;
    /**
     * 
     * @type {SkuBatchUploadResVo}
     * @memberof ResponseSkuBatchUploadResVo
     */
    data?: SkuBatchUploadResVo;
}

/**
 * Check if a given object implements the ResponseSkuBatchUploadResVo interface.
 */
export function instanceOfResponseSkuBatchUploadResVo(value: object): value is ResponseSkuBatchUploadResVo {
    return true;
}

export function ResponseSkuBatchUploadResVoFromJSON(json: any): ResponseSkuBatchUploadResVo {
    return ResponseSkuBatchUploadResVoFromJSONTyped(json, false);
}

export function ResponseSkuBatchUploadResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseSkuBatchUploadResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : SkuBatchUploadResVoFromJSON(json['data']),
    };
}

export function ResponseSkuBatchUploadResVoToJSON(json: any): ResponseSkuBatchUploadResVo {
    return ResponseSkuBatchUploadResVoToJSONTyped(json, false);
}

export function ResponseSkuBatchUploadResVoToJSONTyped(value?: ResponseSkuBatchUploadResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': SkuBatchUploadResVoToJSON(value['data']),
    };
}

